/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const orgPurchaseLimit = {
  header: 'Todos los límites de compra ({{{count}})',

  name: 'Nombre',
  code: 'Código',
  active: 'Estado',
  limit: 'Límite',
  orderApprovalPermissionTipo: 'Tipo',
  threshold: 'Umbral',
  periodRange: 'Periodo',
  currency: 'Divisa',
  orgUnit: 'Unidad para padres',
  unit: 'Unidad para padres',
  actions: '',
  hint: 'Los límites de compra ayudan a controlar el gasto al definir cuánto pueden gastar los compradores por pedido o por semana, mes, trimestre o año. Los límites de compra se asignan a usuarios o grupos de usuarios. Los límites de compra también se asignan a los aprobadores, definiendo cuánto pueden aprobar. Puede asignar límites de compra a muchos usuarios a la vez con grupos de usuarios.',

  details: {
    title: 'Detalles en Límite de compra',
    subtitle: 'Purchase Límite: {{ item.code }}',
  },
  edit: {
    title: 'Edit Purchase Límite',
    subtitle: 'Límites de compra : {{ item.code }}',
  },
  create: {
    title: 'Crear límite de compra',
    subtitle: '',
  },

  sortBy: 'Ordenar por',
  sort: {
    byName: 'Nombre',
    byUnitName: 'Unidad',
  },

  messages: {
    deactivateTitle: 'Disable this purchase limit?',
    deactivate:
      'Los límites de compra deshabilitados ya no se pueden asignar a un usuario o grupo de usuarios. Las asignaciones actuales no tendrán ningún efecto.',
    confirmEnabled: 'Compra Límite {{ item.code }} habilitado con éxito',
    confirmDisabled: 'Compra Límite {{ item.code }} desactivado con éxito',
    update: 'Límite de compra {{ item.code }} actualizado con éxito',
    create: 'Compra Límite {{ item.code }} creado con éxito',
  },
  info: {
    disabledEdit: 'Habilite el límite de compra para permitir la edición.',
    disabledEnable:
      'Unidad debe estar habilitado antes de que se pueda habilitar este límite de compra.',
  },

  per: {
    DAY: 'al día',
    WEEK: 'por semana',
    MONTH: 'por mes',
    QUARTER: 'por trimestre',
    YEAR: 'por año',
  },

  breadcrumbs: {
    list: 'Todos los límites de compra',
    details: '{{code}}',
  },
};
